import { Injectable, inject } from '@angular/core';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { Observable, shareReplay, tap } from 'rxjs';

// services
import { InputsService } from '@app/inputs/services/inputs.service';
import { InputImageUploadAdapterService } from '@app/uploader/upload-section/adapters/input-image-upload-adapter.service';
import { BookFacadeBase } from '../book-facade-base.service';

// misc
import { InputContext } from '@app/user-content/user-input-v2/input.model';
import { PathwayStep } from '@dg/pathways-rsm';
import { ViewModel } from '../../book.model';
import { maxFifteenSkillsValidator } from '@app/user-content/user-input-v2/utils/validators';
@Injectable()
export class BookPathwaysPlansInputFacade extends BookFacadeBase {
  private formBuilder = inject(FormBuilder);

  private form: FormGroup = this.formBuilder.group({
    book: [null, [Validators.required]], // BookFormCtrl_BookSearchError
  });

  constructor(
    public override inputsService: InputsService,
    public override inputImageUploadAdapterService: InputImageUploadAdapterService
  ) {
    super(inputsService, inputImageUploadAdapterService);
  }

  // *******************************************************
  // Overwrites
  // *******************************************************

  public override onNext(form: FormGroup): Observable<ViewModel> {
    super.onNext(form);
    const onNext$ = super.onNext(form).pipe(
      tap(() => {
        form.patchValue({
          book: this.viewModel.book, // BookFormCtrl_BookSearchError
        });
        form.addControl(
          'length',
          this.formBuilder.control(this.viewModel.book.durationUnits)
        );
        form.addControl(
          'tags',
          this.formBuilder.control(this.viewModel.tags, [
            maxFifteenSkillsValidator,
          ])
        );
      })
    );
    onNext$.subscribe();
    return onNext$;
  }

  public override onSubmit(form: FormGroup): void {
    super.onSubmit(form);
  }

  /**
   * Override initializeViewModel
   * @param inputContext
   */
  public override initializeViewModel(
    inputContext: InputContext,
    pathwayStep?: PathwayStep
  ): Observable<ViewModel> {
    super.initializeViewModel(inputContext);

    const API = {
      searchTitle: this.searchTitle(this.form).bind(this), // now that we have a form, initialize the searchTitle function
      onSubmit: this.onSubmit.bind(this),
      onNext: this.onNext.bind(this),
    };

    // initialize new/computed Properties
    const initialVM = {
      ...this.viewModel,
      form: this.form,
      addToCatalog: false, // Can not add books to catalog
      orgContentMetadata: {
        groupIds: [],
        hideFromCatalog: true,
      },
      pathwayStep: pathwayStep,
    };

    return super
      .patchViewModel({ ...API, ...initialVM })
      .pipe(shareReplay({ refCount: false, bufferSize: 1 }));
  }

  /** Not used within pathway add  */
  protected performSuccessSideEffects() {}

  /** Not used within pathway add  */
  protected performFailureSideEffects(
    isEditingContentLocally?: boolean,
    pathwayStep?: PathwayStep
  ) {}
}
